import { DatasourceCanBaseIcon } from '@tableau/icons/DatasourceCanBaseIcon';
import { DatasourceCanPauseIcon } from '@tableau/icons/DatasourceCanPauseIcon';
import { DatasourceCanPlayIcon } from '@tableau/icons/DatasourceCanPlayIcon';
import { DatasourceCanRefreshIcon } from '@tableau/icons/DatasourceCanRefreshIcon';
import { DatasourceTableBaseIcon } from '@tableau/icons/DatasourceTableBaseIcon';
import { DisplayCombinedIcon } from '@tableau/icons/DisplayCombinedIcon';
import { DisplayFullscreenOffIcon } from '@tableau/icons/DisplayFullscreenOffIcon';
import { DisplayFullscreenOnIcon } from '@tableau/icons/DisplayFullscreenOnIcon';
import { DisplayMonitorIcon } from '@tableau/icons/DisplayMonitorIcon';
import { DisplayMonitorOpenIcon } from '@tableau/icons/DisplayMonitorOpenIcon';
import { DisplayPhoneIcon } from '@tableau/icons/DisplayPhoneIcon';
import { DisplayTabletIcon } from '@tableau/icons/DisplayTabletIcon';
import { DownloadBaseIcon } from '@tableau/icons/DownloadBaseIcon';
import { EinsteinEntryIcon } from '@tableau/icons/EinsteinEntryIcon';
import { FilePdfIcon } from '@tableau/icons/FilePdfIcon';
import { FilePowerpointIcon } from '@tableau/icons/FilePowerpointIcon';
import { ImageBaseIcon } from '@tableau/icons/ImageBaseIcon';
import { MailBaseIcon } from '@tableau/icons/MailBaseIcon';
import { MetricBaseIcon } from '@tableau/icons/MetricBaseIcon';
import { MoreDotsIcon } from '@tableau/icons/MoreDotsIcon';
import { NavigationRedoIcon } from '@tableau/icons/NavigationRedoIcon';
import { NavigationReplayIcon } from '@tableau/icons/NavigationReplayIcon';
import { NavigationRevertIcon } from '@tableau/icons/NavigationRevertIcon';
import { NavigationUndoIcon } from '@tableau/icons/NavigationUndoIcon';
import { NotificationAlertLowShieldOutlineBaseIcon } from '@tableau/icons/NotificationAlertLowShieldOutlineBaseIcon';
import { NotificationBellBaseIcon } from '@tableau/icons/NotificationBellBaseIcon';
import { PlaceholdersIcon } from '@tableau/icons/PlaceholdersIcon';
import { RESERVEDDatasourceCanInUseIcon } from '@tableau/icons/RESERVEDDatasourceCanInUseIcon';
import { RESERVEDSpeedErrorIcon } from '@tableau/icons/RESERVEDSpeedErrorIcon';
import { ShareBaseIcon } from '@tableau/icons/ShareBaseIcon';
import { ShowBaseIcon } from '@tableau/icons/ShowBaseIcon';
import { SignpostIcon } from '@tableau/icons/SignpostIcon';
import { SpeechBubbleDualIcon } from '@tableau/icons/SpeechBubbleDualIcon';
import { SpeedBaseIcon } from '@tableau/icons/SpeedBaseIcon';
import { SpeedCheckIcon } from '@tableau/icons/SpeedCheckIcon';
import { SpeedClockIcon } from '@tableau/icons/SpeedClockIcon';
import { SpeedPauseIcon } from '@tableau/icons/SpeedPauseIcon';
import { SpeedRequestIcon } from '@tableau/icons/SpeedRequestIcon';
import { StopwatchRecordIcon } from '@tableau/icons/StopwatchRecordIcon';
import { TableauFileViewBaseIcon } from '@tableau/icons/TableauFileViewBaseIcon';
import { TableauFileViewCustomOnIcon } from '@tableau/icons/TableauFileViewCustomOnIcon';
import { TableauFileViewDualIcon } from '@tableau/icons/TableauFileViewDualIcon';
import { TableauFileViewNewIcon } from '@tableau/icons/TableauFileViewNewIcon';
import { TableauFileViewPencilIcon } from '@tableau/icons/TableauFileViewPencilIcon';
import { TableauFileWorkbookBaseIcon } from '@tableau/icons/TableauFileWorkbookBaseIcon';
import { TableauLogoGrayIcon } from '@tableau/icons/TableauLogoGrayIcon';
import { IconLibraryIcon } from '@tableau/widgets';

export const TOOLBAR_OVERFLOW_ICON_ID = 'toolbar-overflow';
export type ToolbarIconId =
  | 'undo'
  | 'redo'
  | 'revert'
  | 'pause-updates'
  | 'resume-updates'
  | 'replay'
  | 'subscribe'
  | 'metrics'
  | 'alert'
  | 'data'
  | 'watch'
  | 'download'
  | 'download-image'
  | 'download-data'
  | 'download-crosstab'
  | 'download-pdf'
  | 'download-powerpoint'
  | 'download-workbook'
  | 'display'
  | 'commenting'
  | 'edit'
  | 'share'
  | 'open-on-desktop'
  | 'customviews'
  | 'customviews-modified'
  | 'manage-customviews'
  | 'save-as-custom-view'
  | 'lineage'
  | 'lineage-status'
  | 'lineage-severe-status'
  | 'fullscreen'
  | 'fullscreen-exit'
  | 'device-layout-desktop'
  | 'device-layout-tablet'
  | 'device-layout-phone'
  | 'performance'
  | 'refresh'
  | 'acceleration-failed'
  | 'acceleration-off'
  | 'acceleration-on'
  | 'acceleration-pending'
  | 'acceleration-base'
  | 'acceleration-recommended'
  | 'data-orientation'
  | 'public-info-button'
  | typeof TOOLBAR_OVERFLOW_ICON_ID
  | 'placeholder'
  | 'analytics-assistant'
  | 'session-offline'
  | 'offline-reconnecting';

export const IconFromId: { [key in ToolbarIconId]: IconLibraryIcon } = {
  placeholder: PlaceholdersIcon as IconLibraryIcon,
  'toolbar-overflow': MoreDotsIcon as IconLibraryIcon,
  undo: NavigationUndoIcon as IconLibraryIcon,
  redo: NavigationRedoIcon as IconLibraryIcon,
  revert: NavigationRevertIcon as IconLibraryIcon,
  'pause-updates': DatasourceCanPauseIcon as IconLibraryIcon,
  'resume-updates': DatasourceCanPlayIcon as IconLibraryIcon,
  subscribe: MailBaseIcon as IconLibraryIcon,
  metrics: MetricBaseIcon as IconLibraryIcon,
  alert: NotificationBellBaseIcon as IconLibraryIcon,
  data: DatasourceCanBaseIcon as IconLibraryIcon,
  watch: ShowBaseIcon as IconLibraryIcon,
  download: DownloadBaseIcon as IconLibraryIcon,
  'download-image': ImageBaseIcon as IconLibraryIcon,
  'download-data': DatasourceCanBaseIcon as IconLibraryIcon,
  'download-crosstab': DatasourceTableBaseIcon as IconLibraryIcon,
  'download-pdf': FilePdfIcon as IconLibraryIcon,
  'download-powerpoint': FilePowerpointIcon as IconLibraryIcon,
  'download-workbook': TableauFileWorkbookBaseIcon as IconLibraryIcon,
  display: DisplayCombinedIcon as IconLibraryIcon,
  commenting: SpeechBubbleDualIcon as IconLibraryIcon,
  edit: TableauFileViewPencilIcon as IconLibraryIcon,
  share: ShareBaseIcon as IconLibraryIcon,
  'open-on-desktop': DisplayMonitorOpenIcon as IconLibraryIcon,
  customviews: TableauFileViewBaseIcon as IconLibraryIcon,
  'customviews-modified': TableauFileViewCustomOnIcon as IconLibraryIcon,
  'manage-customviews': TableauFileViewDualIcon as IconLibraryIcon,
  'save-as-custom-view': TableauFileViewNewIcon as IconLibraryIcon,
  lineage: DatasourceCanBaseIcon as IconLibraryIcon,
  'lineage-status': RESERVEDDatasourceCanInUseIcon as IconLibraryIcon,
  'lineage-severe-status': RESERVEDDatasourceCanInUseIcon as IconLibraryIcon,
  replay: NavigationReplayIcon as IconLibraryIcon,
  fullscreen: DisplayFullscreenOnIcon as IconLibraryIcon,
  'fullscreen-exit': DisplayFullscreenOffIcon as IconLibraryIcon,
  'device-layout-desktop': DisplayMonitorIcon as IconLibraryIcon,
  'device-layout-tablet': DisplayTabletIcon as IconLibraryIcon,
  'device-layout-phone': DisplayPhoneIcon as IconLibraryIcon,
  performance: StopwatchRecordIcon as IconLibraryIcon,
  refresh: DatasourceCanRefreshIcon as IconLibraryIcon,
  'acceleration-failed': RESERVEDSpeedErrorIcon as IconLibraryIcon,
  'acceleration-off': SpeedPauseIcon as IconLibraryIcon,
  'acceleration-on': SpeedCheckIcon as IconLibraryIcon,
  'acceleration-pending': SpeedClockIcon as IconLibraryIcon,
  'data-orientation': SignpostIcon as IconLibraryIcon,
  'acceleration-base': SpeedBaseIcon as IconLibraryIcon,
  'acceleration-recommended': SpeedRequestIcon as IconLibraryIcon,
  'public-info-button': TableauLogoGrayIcon as IconLibraryIcon,
  'analytics-assistant': EinsteinEntryIcon as IconLibraryIcon,
  'session-offline': NotificationAlertLowShieldOutlineBaseIcon as IconLibraryIcon,
  'offline-reconnecting': NotificationAlertLowShieldOutlineBaseIcon as IconLibraryIcon,
};
